<template>
  <v-app class="w-100">
    <!-- ヘッダーコンポーネント -->
    <div class="background-bg d-flex justify-center header-wrapper">
      <div class="d-flex contents-max-width w-100" :class="addBorderClassIfNecessary()">
        <!-- ヘッダー -->
        <AppHeader />
      </div>
    </div>

    <!-- メインコンテンツ -->
    <v-main class="background-bg d-flex justify-center mx-0 w-100">
      <div class="contents-max-width h-100 w-100" :class="addBorderClassIfNecessary()">
        <slot />
      </div>
    </v-main>
  </v-app>
</template>

<script setup lang="ts">
import { useDisplay } from 'vuetify';
import AppHeader from '~/components/layout/AppHeader.vue';

const { width } = useDisplay();
/**
 * 画面幅がタブレット端末以上の場合はコンテンツの幅に合わせて枠線を引く
 */
const addBorderClassIfNecessary = () => {
  if (width.value > 1024) {
    return 'border-s-md border-e-md';
  }
};
</script>

<style lang="scss" scoped>
@use '~/assets/scss/_base.scss' as vars;

.background-bg {
  background-color: vars.$color-background;
}

.header-wrapper {
  height: 4rem;
}

.contents-max-width {
  max-width: vars.$content-max-width;
}
</style>
